import { IVehicle } from './GvfService';

export class VehicleCommissionDataHelper {
    private readonly possibleYears: string[];

    constructor(private readonly bids: string[]) {
        const currentYear = new Date().getFullYear();
        this.possibleYears = [`${currentYear}`, `${currentYear - 1}`];
    }

    public getAllCommissionVehicleCombinations(vehicle: IVehicle): IVehicle[] {
        if (vehicle.bid) {
            return [vehicle];
        }

        if (vehicle.commissionNumberYear) {
            return this.bids.map(bid => {
                return {...vehicle, bid}
            })
        } else {
            return this.possibleYears.map(year =>
                this.getAllCommissionVehicleCombinations({
                    ...vehicle,
                    commissionNumberYear: year
                })).flat()
        }
    }
}